// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"877dba0a","732":"0897edff","977":"1f3f69db"}[chunkId] + ".chunk.js";
};